export const IMMUNIZATIONS = {
  key: 'IMMUNIZATIONS',
  value: 7,
  group: 2,
  title: 'health-record.vaccinations.title',
  menu_title: 'health-record.vaccinations.title',
  icon: 'needle',
  editor: 'ImmunizationEditor',
  message_translate: 'health-record.vaccinations.message',
  sub_title: 'Immunization',
  imageURL: require('@assets/images/Health-Record-Icons/Icon-Immunizations.svg'),
  model_name: 'immunization',
  resource: 'hr/immunization/',
  plain_resource: 'immunization',
  id: 'hr_id',
  headers: [
    {
      text: 'health-record.vaccinations.name',
      value: 'record.immunization',
    },
    {
      text: 'health-record.vaccinations.dose-number',
      value: 'record.dose_number',
    },
    {
      text: 'health-record.vaccinations.occurrence',
      value: 'record.date_formatted',
    },
    {
      text: 'health-record.vaccinations.reaction',
      value: 'record.reaction.value',
    },
    {
      text: 'health-record.actions',
      value: 'actions',
      sortable: false,
      width: '100px',
    },
  ],
  sortables: {
    record: {
      immunization: 'immunization',
      series_doses: 'series_doses',
      dose_number: 'dose_number',
      date_formatted: 'date',
      reaction: {
        value: 'reaction',
      },
      supplement: 'supplement',
      ingredient: 'ingredient',
    },
  },
  show_menu: true,
  background: 'linear-gradient(122.25deg, #0D47A1 3.07%, #1976D2 100%)',
  color: '#1462BD',
  opaque: '#CCDCEE',
}
